/**
 * Load optional Horizon enhancements as soon as matching markup exists.
 * Observes section responses and Quick Add inserts as well as the initial page.
 * Core navigation, cart, variant selection and animation modules stay eager.
 */
const pending = new Map([
  ['deferred-media, product-model', () => import('@theme/media')],
  ['product-price', () => import('@theme/product-price')],
  ['product-sku-component', () => import('@theme/product-sku')],
  ['product-inventory', () => import('@theme/product-inventory')],
  ['layered-slideshow-component', () => import('@theme/layered-slideshow')],
  ['video-background-component', () => import('@theme/video-background')],
  ['volume-pricing', () => import('@theme/volume-pricing')],
  ['price-per-item', () => import('@theme/price-per-item')],
  ['volume-pricing-info', () => import('@theme/volume-pricing-info')],
]);

/** @param {Element | Document} root */
function enhance(root) {
  for (const [selector, load] of pending) {
    if (!(root instanceof Element && root.matches(selector)) && !root.querySelector(selector)) continue;
    pending.delete(selector);
    load().catch((error) => {
      pending.set(selector, load);
      console.error(`[theme] Could not load ${selector}`, error);
    });
  }
}

const observer = new MutationObserver((records) => {
  if (!pending.size) return;
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node instanceof Element) enhance(node);
    }
  }
});
observer.observe(document.documentElement, { childList: true, subtree: true });
enhance(document);
